import React from 'react';
import PropTypes from 'prop-types';

const styles = {
  pageStyle: {
    marginBottom: '99px',
  },
  primaryRow: {
    padding: '10px 0 10px 10px',
  },
  primaryCol: {
    fontSize: '20pt',
    fontWeight: 'bold',
    lineHeight: '25px',
  },
  secondaryRow: {
    padding: '10px 10px 10px 0',
  },
  secondaryCol: {
    fontSize: '20pt',
    lineHeight: '25px',
    textAlign: 'right',
  },
  secondaryRowAlt: {
    padding: '0 10px 10px 10px',
  },
  secondaryColAlt: {
    fontSize: '20pt',
    lineHeight: '25px',
  },
  contentBorder: {
    borderTop: '5px solid rgb(250, 167, 24)',
  },
};

const BodyHeader = props => (<div className='row'>
  <div className='col-md-12'>
    <div className='row'>
      <div className='col-sm-8 col-md-8 col-lg-8'>
        <div className='row hidden-xs' style={styles.primaryRow}>
          <div className='col-md-12' style={styles.primaryCol}>
            {props.primary}
          </div>
        </div>
        <div className='row visible-xs' style={styles.primaryRow}>
          <div className='col-md-12' style={styles.primaryCol}>
            {props.primaryAlt}
          </div>
        </div>
      </div>
      <div className='col-sm-4 col-md-4 col-lg-4'>
        <div className='row hidden-xs' style={styles.secondaryRow}>
          <div className='col-md-12' style={styles.secondaryCol}>
            {props.secondary}
          </div>
        </div>
        <div className='row visible-xs' style={styles.secondaryRowAlt}>
          <div className='col-md-12' style={styles.secondaryColAlt}>
            {props.secondaryAlt}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className='row'>
    <div className='col-md-12' style={styles.contentBorder} />
  </div>
</div>);

BodyHeader.propTypes = {
  primary: PropTypes.string,
  primaryAlt: PropTypes.string,
  secondary: PropTypes.string,
  secondaryAlt: PropTypes.string,
};

export default BodyHeader;



// WEBPACK FOOTER //
// ./shared/components/BodyHeader/BodyHeader.js